import { Box, TextField, MenuItem, Button } from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

export function TransfersFilterBar({
  searchText, setSearchText,
  filterType, setFilterType,
  filterSite, setFilterSite,
  filterStartDate, setFilterStartDate,
  filterEndDate, setFilterEndDate,
  sites,
  transferTypeLabels,
  onSearch,
  onReset,
}) {
  return (
    <Box sx={{ display: 'flex', gap: 2, mb: 2, flexWrap: 'wrap', pl: 1 }}>
      <TextField
        label="搜尋貨物或備註"
        size="small"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
      />

      <TextField
        select
        label="轉移原因"
        size="small"
        value={filterType}
        onChange={(e) => setFilterType(e.target.value)}
        sx={{ minWidth: 150 }}
      >
        <MenuItem value="">全部</MenuItem>
        {Object.entries(transferTypeLabels).map(([type, name]) => (
          <MenuItem key={type} value={type}>{name}</MenuItem>
        ))}
      </TextField>

      <TextField
        select
        label="地盤"
        size="small"
        value={filterSite}
        onChange={(e) => setFilterSite(e.target.value)}
        sx={{ minWidth: 150 }}
      >
        <MenuItem value="">全部</MenuItem>
        {sites.map(site => (
          <MenuItem key={site.id} value={site.id}>{site.name}</MenuItem>
        ))}
      </TextField>

      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          label="開始日期"
          format="YYYY/MM/DD"
          maxDate={dayjs()}
          value={filterStartDate}
          onChange={(v) => setFilterStartDate(v)}
          slotProps={{ textField: { size: 'small' }}}
        />
      </LocalizationProvider>

      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          label="結束日期"
          format="YYYY/MM/DD"
          maxDate={dayjs()}
          value={filterEndDate}
          onChange={(v) => setFilterEndDate(v)}
          slotProps={{ textField: { size: 'small' }}}
        />
      </LocalizationProvider>

      <Button variant="contained" onClick={onSearch}>搜尋</Button>
      <Button variant="contained" onClick={onReset}>重設</Button>
    </Box>
  );
}
